/**
 * @fileoverview Scout Eval Constants
 * @description Score bands, filters, and storage limits for the Scout evaluation module.
 * @module features/ScoutEval/constants
 */

export const BAND_COLORS = {
  green: '#008653',
  amber: '#D28B00',
  red: '#C81E3A',
  'not-run': '#5B6573',
};

export const BAND_LABELS = {
  green: 'Green — meets target (≥ 0.85)',
  amber: 'Amber — monitor (≥ 0.75)',
  red: 'Red — below target (< 0.75)',
};

export const BAND_STATUS = {
  green: 'Meets target',
  amber: 'Monitor',
  red: 'Below target',
  'not-run': 'Not scored',
};

export const BAND_FILTERS = [
  { value: 'all', label: 'All' },
  { value: 'green', label: 'Green' },
  { value: 'amber', label: 'Amber' },
  { value: 'red', label: 'Red' },
];

export const MOVEMENT_LABELS = {
  improved: 'Improved',
  regressed: 'Regressed',
  unchanged: 'Unchanged',
  added: 'New',
  removed: 'Removed',
};

export const MOVEMENT_COLORS = {
  improved: '#008653',
  regressed: '#C81E3A',
  unchanged: '#5B6573',
  added: '#0097A9',
  removed: '#7C3AED',
};

/** Deltas smaller than this are treated as noise rather than movement. */
export const MOVEMENT_EPSILON = 0.005;

export const SCOUT_STORAGE_KEY = 'scout-eval-runs';

export const MAX_SCOUT_RUNS = 25;
